const NAVBAR_MAX_WIDTH = "300px";
const NAVBAR_MIN_WIDTH = "100px";
const NAVBAR_WIDTH = "8vmax";
const EARTH_SIZE = 45;
export { NAVBAR_MIN_WIDTH, NAVBAR_WIDTH, EARTH_SIZE, NAVBAR_MAX_WIDTH };
